import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M2 4.667h12V6H2zm0 4h12V7.333H2zm0 2.666h5.25V10H2zM2 14h5.25v-1.333H2zm8.558-1.887L9.5 11.167l-1.057.94L10.557 14 14 10.947 12.935 10zM2 2v1.333h12V2z"
    }, null, -1)
  ])))
}
export default { render: render }